import { defineField, defineType } from 'sanity'

import { strongEmLink } from '../../../data/richText'

export default defineType({
  title: 'APEX Quality Standard',
  name: 'apexQualityStandard',
  type: 'document',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
    }),
    defineField({
      title: 'Features',
      name: 'features',
      type: 'array',
      of: [
        {
          type: 'string',
        },
      ],
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title }) {
      return {
        title,
        subtitle: 'APEX Quality Standard',
      }
    },
  },
})